import convertToImperialIfMetric from 'helpers/convertToImperialIfMetric'
import { POSSIBLE_PPFS } from 'helpers/globals'

export default function nextPossiblePpf(ppf, isImperial) {
  const convertedPpf = convertToImperialIfMetric({ value: ppf, isImperial })
  return POSSIBLE_PPFS.reduce((prev, curr) => Math.abs(curr - convertedPpf) < Math.abs(prev - convertedPpf) ? curr : prev)
}



// WEBPACK FOOTER //
// ./src/helpers/ppfPreview/nextPossiblePpf.js